export const AllBeneficiary = [
    {value:"1", label:"Administração"},
    {value:"2", label:"Outros"},
    {value:"3", label:"Pequenas Empresas"},
    {value:"4", label:"Média Empresas"},
    {value:"5", label:"Empreendimentos"},
    {value:"6", label:"Grupo de Investigação"},
    {value:"7", label:"Associações de Clusters e Empresas"},
    {value:"8", label:"Fundações"},
    {value:"9", label:"Centros Tecnológicos"},
    {value:"10", label:"Grande Empresa"},
    {value:"11", label:"Startup"},
    {value:"12", label:"Midcap"},
]